import { useEffect } from 'react';

/**
 * Replaces ** markers with links to general disclaimer
 */
export const replaceGeneralDisclaimerMarkers = (html: string, fullHtml?: string): string => {
  return html.replace(/(^|[^<])\*\*(?![^<]*<\/a>)(?![^<]*id="generalDisclaimer")/g, (match, p1) => {
    const contextHtml = fullHtml || html;
    if (
      /<a[^>]*>[^<]*\*\*[^<]*<\/a>/.test(match) ||
      /<[^>]*id="generalDisclaimer"[^>]*>[^<]*\*\*[^<]*<\/[^>]*>/.test(match) ||
      /<div[^>]*id="generalDisclaimer"[^>]*>[^]*<p[^>]*>[^<]*\*\*[^<]*<\/p>[^]*<\/div>/.test(
        contextHtml
      )
    ) {
      return match;
    }
    return `${p1}<a href="#generalDisclaimer" class="disclaimer-link" aria-label="link to disclaimer">**</a>`;
  });
};

/**
 * Replaces * markers with links to FDA disclaimer
 */
export const replaceFdaDisclaimerMarkers = (html: string, fullHtml?: string): string => {
  return html.replace(/(^|[^<])\*(?![^<]*<\/a>)(?![^<]*id="fdaDisclaimer")/g, (match, p1) => {
    const contextHtml = fullHtml || html;
    if (
      /<a[^>]*>[^<]*\*[^<]*<\/a>/.test(match) ||
      /<[^>]*id="fdaDisclaimer"[^>]*>[^<]*\*[^<]*<\/[^>]*>/.test(match) ||
      /<div[^>]*id="fdaDisclaimer"[^>]*>[^]*<p[^>]*>[^<]*\*[^<]*<\/p>[^]*<\/div>/.test(contextHtml)
    ) {
      return match;
    }
    return `${p1}<a href="#fdaDisclaimer" class="disclaimer-link" aria-label="link to disclaimer">*</a>`;
  });
};

/**
 * Processes HTML content to add accessibility links for disclaimer markers
 */
export const processAccessibilityMarkers = (html: string): string => {
  return replaceFdaDisclaimerMarkers(replaceGeneralDisclaimerMarkers(html, html), html);
};

/**
 * Adds accessibility links for disclaimer markers to the given element
 */
const useAddAccessibility = (
  elementRef: React.RefObject<HTMLElement | null>,
  condition: boolean
) => {
  useEffect(() => {
    if (condition && elementRef.current) {
      const targetElement = elementRef.current;
      if (targetElement) {
        const updatedHtml = processAccessibilityMarkers(targetElement.innerHTML);
        targetElement.innerHTML = updatedHtml;
      }
    }
  }, [elementRef, condition]); // Dependency array to run when elementRef or conditional changes
};

export default useAddAccessibility;
